/// <amd-module name="VSS/Features/SecurityUI/RolesDialog/AddRoleAssignmentDialog" />
export * from "./Components/AddRoleAssignmentDialog";
export { IAddRoleAssignmentDialogProps } from "VSS/Features/SecurityUI/RolesDialog/AddRoleAssignmentDialog.Types";
